<template>
  <div class="articles">
    <div class="container articles-container" v-cloak>
      <div
        v-for="article in articles"
        :key="article.id"
        :class="`articles__item ${article.is_pinned ? 'pinned' : ''}`"
        @click="$emit('openArticle', article.id)"
      >
        <div class="articles__image">
          <img
            v-if="article?.poster_url"
            :src="article.poster_url"
            :alt="article.title"
          />
        </div>
        <div class="articles__info">
          <div v-if="article.is_pinned" class="articles__pin">
            <PinIcon />
          </div>
          <div
            class="articles__description"
            v-html="parseText(article.description)"
          ></div>
        </div>
      </div>
      <InlineLoader v-show="inlineLoaderShow" />
      <ObserverBlock @intersect="intersected" />
    </div>
    <PageLoader v-show="pageLoaderShow" />
  </div>
</template>

<script>
import { getPosts } from '@/functions/API';
import ObserverBlock from '@/components/blocks/observer/ObserverBlock.vue';
import PageLoader from '@/components/blocks/loader/PageLoader.vue';
import PinIcon from '@/components/icons/PinIcon.vue';

export default {
  name: 'CategoryBlock',
  components: {
    ObserverBlock,
    PageLoader,
    PinIcon,
  },
  props: {
    articletype: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      articles: [],
      inlineLoaderShow: true,
      page: 0,
      endContent: false,
    };
  },
  watch: {
    $route() {
      this.articles = [];
      this.inlineLoaderShow = true;
      this.page = 0;
      this.endContent = false;
      this.getData();
    },
  },
  methods: {
    getData() {
      const req = {};
      req.visible_in = this.articletype;
      if (this.$route.params.id) {
        req.category_id = parseInt(this.$route.params.id);
      }
      getPosts(this.page, req, (res) => {
        if (res !== false) {
          if (res?.length > 0) {
            if (this.articles.length > 0) {
              this.articles = this.articles.concat(res);
            } else {
              this.articles = res;
            }
            this.inlineLoaderShow = false;
          } else {
            this.endContent = true;
          }
        }
      });
    },
    intersected() {
      if (!this.endContent) {
        this.inlineLoaderShow = true;
        this.page += 1;
        this.getData();
      }
    },
    parseText(text) {
      const regex = /\[(https?:\/\/[^\]|]+|id=\d+)\|([^\]]+)\]/g;
      return text.replace(regex, (match, url, linkText) => {
        return linkText;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.articles {
  margin-top: 16px;
  margin-bottom: 16px;

  p {
    margin-bottom: 6px;
  }
  &-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
    margin-bottom: 60px;
  }
  &__item {
    width: 100%;
    overflow: hidden;
    position: relative;
    border-radius: 12px;
    cursor: pointer;
    &.pinned {
      border-radius: 16px;
      border: 2px solid var(--color-blue);
    }
  }
  &__image {
    width: 100%;
    height: calc((100vw - 32px) / 16 * 9);
    max-height: 315px;
    z-index: 0;
    display: flex;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 14px;
      background-color: var(--color-gray);
    }
  }
  &__pin {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-blue);
    z-index: 2;
  }
  &__info {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 16px;
    background-color: var(--color-white-opacity);
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 20px;
  }
  &__description {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    color: var(--color-black);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
